/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ErrorDto } from './ErrorDto';

export type Issuance = {
    id: number;
    issuanceOfferCode: string;
    offerDescription?: string;
    milesAmount?: number;
    status: Issuance.status;
    errors?: Array<ErrorDto>;
};

export namespace Issuance {

    export enum status {
        CREATED = 'CREATED',
        PENDING = 'PENDING',
        CONFIRMED = 'CONFIRMED',
        REJECTED = 'REJECTED',
        HELD = 'HELD',
        MAX_RETRIES = 'MAX_RETRIES',
        ERROR = 'ERROR',
        RETURNS_NON_ISSUANCE = 'RETURNS_NON_ISSUANCE',
        BACKOUT = 'BACKOUT',
        BACKED_OUT = 'BACKED_OUT',
    }


}

